import type { RhfSelectActionOption } from '@core/components/forms/fields/RhfSelect';
import { useAppContext } from '../context/AppContext';

export function useCreateActionOption<R extends { id: number }>(
  label: string,
  renderDialog: RhfSelectActionOption<R>['renderDialog']
): RhfSelectActionOption<R> {
  const { refreshContext } = useAppContext();
  return {
    label,
    renderDialog,
    mapToValue: (entity) => String(entity.id),
    onComplete: async () => {
      await refreshContext();
    },
  };
}
